import React from "react";

const About = () => {
  return (
    <section className="py-16 bg-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-8">
          About Us
        </h2>
        <p className="text-lg text-gray-700 text-justify mx-auto mb-4">
          Welcome to <span className="byte-bazaar bg-gradient-to-r from-pink-600 via-violet-500 to-cyan-400 bg-clip-text font-semibold text-2xl text-transparent">
            ByteBazaar
          </span>,
          your ultimate destination for cutting-edge electronics and innovative
          gadgets. We are passionate about bringing you the latest and most
          advanced technology, carefully curated from top manufacturers
          worldwide. At{" "}
          <span className="byte-bazaar bg-gradient-to-r from-pink-600 via-violet-500 to-cyan-400 bg-clip-text font-semibold text-2xl text-transparent">
            ByteBazaar
          </span>, we believe
          in offering not just products, but an experience that enhances your
          digital lifestyle.
        </p>
        <p className="text-lg text-gray-700 text-justify mx-auto mb-4">
          Our mission is to provide a seamless and enjoyable shopping
          experience, ensuring you have access to the best gadgets, whether it's
          the latest smartphones, premium audio gear, smart wearables, or gaming
          accessories. We prioritize quality, innovation, and reliability,
          making sure every product meets our high standards. With an intuitive
          interface and secure checkout, shopping at{" "}
          <span className="byte-bazaar bg-gradient-to-r from-pink-600 via-violet-500 to-cyan-400 bg-clip-text font-semibold text-2xl text-transparent">
            ByteBazaar
          </span> is fast,
          easy, and hassle-free.
        </p>
        <p className="text-lg text-gray-700 text-justify mx-auto">
          At <span className="byte-bazaar bg-gradient-to-r from-pink-600 via-violet-500 to-cyan-400 bg-clip-text font-semibold text-2xl text-transparent">
            ByteBazaar
          </span>, our
          customers are at the heart of everything we do. We are committed to
          exceptional service, whether you need product recommendations,
          technical support, or assistance with your order. Join us on this
          journey as we bring you the future of technology with dedication and
          expertise. Thank you for choosing{" "}
          <span className="byte-bazaar bg-gradient-to-r from-pink-600 via-violet-500 to-cyan-400 bg-clip-text font-semibold text-2xl text-transparent">
            ByteBazaar
          </span>, where
          innovation meets convenience!
        </p>
      </div>
    </section>
  );
};

export default About;
